import { IProductMeasure, IProduct } from '@inter-ikea-kompis/types/lib';
import { Product } from '@inter-ikea-storageone/range';
import { SelectedProduct } from 'ducks/products';

export const mmToCm = (millimeter: number, round: boolean = false): number =>
  round ? Math.round(millimeter / 10) : millimeter / 10;
export const cmToMm = (cm: number): number => cm * 10;
export const mmToInch = (millimeter: number, round: boolean = false): number =>
  round ? Math.round(millimeter * 0.0393701) : millimeter * 0.0393701;
export const inchToMm = (inch: number, round: boolean = false): number => {
  return round ? Math.round((inch * 25.4) / 10) * 10 : inch * 25.4;
};

const getDimensionValue = (useMetric: boolean, unit: string, measure?: IProductMeasure): string => {
  if (!measure) {
    return '';
  }

  return `${measure.typeName} ${
    useMetric ? `${Math.round(mmToCm(measure.value))} ` : measure.textImperial.replace('"', '')
  }${unit}`;
};

const getTextDimensionValue = (unit: string, value: string, dimension: string): string => {
  return `${dimension} ${value} ${unit}`;
};

export const getIProductDimensionsForNarration = (
  product: IProduct,
  unit: string,
  useMetric: boolean
): string => {
  if (!product.content?.measure) {
    return '';
  }

  const width = product.content?.measure.find(m => m.typeCode === '00047');
  const height = product.content?.measure.find(m => m.typeCode === '00041');
  const depth = product.content?.measure.find(m => m.typeCode === '00044');

  const dimensions = `${getDimensionValue(useMetric, unit, width)}, ${getDimensionValue(
    useMetric,
    unit,
    height
  )}, ${getDimensionValue(useMetric, unit, depth)}`;

  return dimensions;
};

export const getProductDimensionsForNarration = (
  formatMessage: ({ id }: { id: string }) => string,
  product?: Product | SelectedProduct | null
): string => {
  if (!product) {
    return '';
  }

  const width = product.communicatedDimensionsLocalized.width;
  const height = product.communicatedDimensionsLocalized.height;
  const depth = product.communicatedDimensionsLocalized.depth;
  const unit = product.communicatedDimensionsLocalized.unit;

  const dimensions = `${getTextDimensionValue(
    unit,
    width,
    formatMessage({ id: 'storageone.width' })
  )}, ${getTextDimensionValue(
    unit,
    height,
    formatMessage({ id: 'storageone.height' })
  )}, ${getTextDimensionValue(unit, depth, formatMessage({ id: 'storageone.depth' }))}`;

  return dimensions;
};
